// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"aD-z","smallCardRow":"bD-z","largeCardRow":"cD-z","productSearchRow":"dD-z","curatedRow":"eD-z"};